<template>
  <ul class="list">
    <li class="line" v-for="tag in tags" :key="tag.id">
      <button class="tag-button" @click="() => toTagTab(tag)">
        <TagSvgWithColor :tag="tag" />
        <div :class="['menuText', { menuTextActive: isMenuOpen }]">
          {{ tag.name }}
        </div>
      </button>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from "vuex";
import TagSvgWithColor from "./TagSvgWithColor.vue";
import { purchasesPath } from "@/router/purchases";
import { isEmpty } from "@/utils/lodash";
import { mapActions } from "vuex";

export default {
  name: "TagMenuList",
  components: {
    TagSvgWithColor,
  },
  props: {
    isMenuOpen: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters("tags", ["tags"]),
  },
  methods: {
    ...mapActions("filterTabs", ["setCurrentTab"]),
    toTagTab(tab) {
      if (
        parseInt(this.$route.params.id) === tab.id &&
        isEmpty(this.$route.query)
      ) {
        this.setCurrentTab(tab);
        return;
      }
      this.$router.push(`${purchasesPath}/${tab.id}`);
      this.setCurrentTab(tab);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/commonStyles.less";

.list {
  display: flex;
  flex-direction: column;

  .line {
    user-select: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 40px;
    height: 40px;
    transition: background-color 0.3s ease;
    &:hover {
      background-color: #3c3e3a;
    }

    .tag-button {
      display: flex;
      align-items: center;
      padding-left: 31px;
      position: relative;
      width: 100%;
      height: 100%;

      .menuText {
        transition: 0.3s ease opacity;
        position: absolute;
        left: 70px;
        width: max-content;
        opacity: 0;
        color: #fffff9;
      }

      .menuTextActive {
        opacity: 1;
      }
    }
  }
}
</style>
